import { ChiptaElement, html, css } from 'chipta-libs/main.js';
import './font-awesome.js';

export class InfoBox extends ChiptaElement {

  static get properties() {
    return {
      title: {type: String},
      showDescription: {type: Boolean}
    };
  }

  render() {

    return html`

      <div id="container" align=${this.boxAlign}>

        <div
          id="box"
          type=${this.getAttribute('type')}
        >

          ${this.titleEl}
          ${this.spacer}

          <div id="description" ?hidden=${!this.showDescription}>
            ${this.descriptionIcon}
            <div>
              <slot @slotchange=${this.handleSlotChange}></slot>
            </div>
          </div>

        </div>

      </div>

    `;

  }

  get boxAlign() {
    return this.getAttribute('align') || 'left';
  }

  get titleEl() {

    if (!this.title) {
      return;
    }

    return html`
      <h5 id="title">
        ${this.iconEl}
        ${this.title}
      </h5>
    `;

  }

  get iconEl() {
    return html`
      <font-awesome id="icon" icon=${this.iconName} icon-style="custom"></font-awesome>
    `;
  }

  get iconName() {

    switch (this.getAttribute('type')) {

      case 'success':
        return 'check';

      case 'warning':
        return 'exclamation-triangle';

      case 'error':
        return 'times-circle';

      default:
      case 'info':
        return 'info';

    }

  }

  get descriptionIcon() {

    if (this.title) {
      return;
    }

    return this.iconEl;

  }

  get spacer() {
    if (this.title && this.showDescription) {
      return html`<div id="spacer"></div>`;
    }
  }

  get boxStyle() {
    return 'default';
  }

  handleSlotChange() {
    this.showDescription = true;
  }

  static get styles() {

    return css`

      :host {
        display: block;
      }

      * {
        box-sizing: border-box;
      }

      #container[align=left] {
        text-align: left;
      }

      #container[align=center] {
        text-align: center;
      }

      #box {
        display: inline-flex;
        flex-direction: column;
        max-width: 600px;
        padding: 15px;
        padding-right: 20px;
        background: #fced74;
        border: 1px solid #CCC;
        border-radius: 2px;
        font-size: 14px;
        color: black;
      }

      :host([wide]) #box {
        display: flex;
        max-width: none;
      }

      #container[align=left] #box {
        justify-content: left;
        text-align: left;
        align-items: left;
      }

      #container[align=center] #box {
        justify-content: center;
        text-align: center;
        align-items: center;
      }

      #container[align=right] #box {
        justify-content: right;
        text-align: right;
        align-items: right;
      }

      #box[type=success] {
        background: #d2ff96;
      }

      #box[type=warning] {
        background: #de6f2a;
        color: white;
      }

      #box[type=error] {
        background: #de2a2a;
        color: white;
      }

      #title {
        margin: 0;
        padding: 0;
        font-size: 15px;
        font-weight: 600;
      }

      #container[align=right] #title {
        justify-content: right;
      }

      #spacer {
        margin-top: 10px;
      }

      #title, #description {
        display: inline-flex;
        align-items: center; /* Vertical placement of content within the box */
      }

      #description[hidden] {
        display: none;
      }

      #title #icon {
        padding: 0 7px 0 0;
      }

      #description #icon {
        padding: 0 10px 0 0;
      }

      @media screen and (max-width: 500px) {

        #box {
          display: flex;
          max-width: none;
          border-width: 0 0 1px 0;
        }

      }

    `;

  }

}

customElements.define('info-box', InfoBox);
